import { appURLs } from "@/app/constants.mjs";

export default function getProfileAvatar(): string {
  return `${appURLs.CDN}/blitz/eft/eft-profile-avatar-default.webp`;
}
